<template>
  <div class="animated fadeIn" v-if="canFindImage && temporaryDesign && temporaryDesign.fullImage">
    <br />
    <b-row>
      <b-col sm="12" v-if="temporaryDesign && me && me.subscription.status != 1 && !canDownloadFree">
        <b-alert show variant="warning">Assine agora para baixar sem marca d'água!</b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6" v-if="temporaryDesign">
        <b-row>
          <b-col>
            <related-posts v-on:templateSelected="goToTemplate" v-if="this.temporaryDesign" v-model="this.temporaryDesign.originalTemplateId" :isTemporary="true"/>
          </b-col>
        </b-row>
        <b-card>
          <div slot="header">
            <strong>Exportar Sleeker</strong>
          </div>
          <b-form class="text-center">
            <img
              v-show="loaded && !this.isMobileScreen"
              @error="notLoaded()"
              v-on:load="loaded=true"
              style="max-height: 450px;"
              v-bind:src="((me && me.subscription && me.subscription.status == 1) || canDownloadFree) ? fullImage : watermarked"
            />
            <img
              v-show="loaded && this.isMobileScreen"
              @error="notLoaded()"
              v-on:load="loaded=true"
              style="max-height: 300px; max-width: 100%;"
              v-bind:src="((me && me.subscription && me.subscription.status == 1) || canDownloadFree) ? fullImage : watermarked"
            />
            <spinner v-if="!loaded"></spinner>

            <!-- :href="item.url"
  v-text="Download"
            @click.prevent="downloadItem(item.url)"-->  
            <br/>
            <b-col v-if="challenge"> 
              <br/>
               <button
                v-bind:href="temporaryDesign.fullImage"
                @click.prevent="goToChallenge()"
                class="btn btn-block btn-outline-warning bg-white m-t btn-desafio"
                download
              >
                Voltar para o Desafio
              </button>
              <br/>
            </b-col>
            <b-col v-if="(loaded && isInstagramBrowser)"> 
              <b-row>
                <p style="text-align: left;"><strong>ATENÇÃO</strong> Você precisa acessar o Sleeker a partir do seu navegador para baixar este post. Veja como: </p>
                <img src="/img/bug-instagram.gif"  style="max-width: 100%;" />
                <!--<p>Siga os passos:</p>
                <p>1. Toque no botão com três pontos, localizado no canto superior direito</p>
                <p>2. No menu que aparece, clique na opção de abrir no navegador ("Abrir no Chrome", "Abrir no Safari", etc.)</p>-->
              </b-row>
            </b-col>
            <button
              v-bind:href="temporaryDesign.fullImage"
              @click.prevent="downloadItem(temporaryDesign.fullImage)"
              v-else-if="loaded && (!me || !me.subscription || (me.subscription.status != 1 && !canDownloadFree) || me.subscription.isExpired) && !temporaryDesign.originalIsPersonal && !challenge"
              class="btn btn-block btn-outline-primary bg-white m-t"
              disabled
            >
              <i class="fa fa-download"></i>
              Assine para baixar em .PNG
            </button>

            <button
              v-bind:href="temporaryDesign.fullImage"
              @click.prevent="downloadItem(temporaryDesign.fullImage)"
              v-else-if="loaded"
              class="btn btn-block btn-outline-primary bg-white m-t"
              download
            >
              <i class="fa fa-download"></i>

              {{ 'Baixar ' + templateName + ' em .png' }}
            </button>

            <!--<button
              v-else-if="loaded && isIOS"
              disabled
              class="btn btn-block btn-outline-primary bg-white m-t"
              type="button"
            >
              <i class="fa fa-download"></i>
              &nbsp; {{ ((me && me.subscription && me.subscription.status == 1) || canDownloadFree) ? 'Aperte e segure na imagem para salvar' : 'Assine para baixar sem marca'}}
            </button>-->
            <p v-if="loaded && !isInstagramBrowser && ((me && me.subscription && me.subscription.status == 1) || canDownloadFree)">Não conseguiu baixar? <a :href="temporaryDesign.fullImage">Clique aqui</a></p>
          </b-form>
        </b-card>
      </b-col>
      <b-col md="6" v-if="temporaryDesign">
        <b-row v-if="temporaryDesign && temporaryDesign.subtitle">
          <b-col sm="12">
            <b-card>
              <subtitle-box :subtitle="temporaryDesign.subtitle" :instructions="temporaryDesign.instructions"/>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-card>
              <div slot="header">Salvar em Meus {{templateName}}s</div>
              <b-form>
                <b-form-group label="Categorias">
                  <multiselect
                    v-model="selectedCategories"
                    class="background-multiSelect"
                    placeholder="Selecione uma categoria"
                    label="name"
                    track-by="_id"
                    :options="categoriesList"
                    :multiple="true"
                    :taggable="true"
                    :select-label="'Selecionar'"
                    :deselect-label="'Remover'"
                    :selected-label="'Selecionado'"
                    @tag="addTag"
                  ></multiselect>
                </b-form-group>
                <p>Para adicionar nova categoria, digite o nome e tecle enter.</p>
                <div v-if="isAdmin">
                  <b-form-group v-if="temporaryDesign && !temporaryDesign.customColors" label="Escolha a cor:">
                    <b-form-select v-model="color" :options="[
                      { value: 'Amarelo', text: 'Amarelo' },
                      { value: 'Vermelho', text: 'Vermelho' },
                      { value: 'Verde', text: 'Verde' },
                      { value: 'Azul', text: 'Azul' },
                      { value: 'Rosa', text: 'Rosa' },
                      { value: 'Laranja', text: 'Laranja' }
                    ]"></b-form-select>
                  </b-form-group>
                  <b-form-group label="Tipo de edição permitida:">
                    <b-form-checkbox-group
                      id="checkbox-group-2"
                      v-model="temporaryDesign.expressEdition"
                      v-bind:true-value="1"
                      v-bind:false-value="0"
                      name="flavour-2"
                    >
                      <b-form-checkbox value="true">Expressa</b-form-checkbox>
                    </b-form-checkbox-group>
                    <b-form-checkbox-group
                      id="checkbox-group-3"
                      v-model="temporaryDesign.advancedEdition"
                      v-bind:true-value="1"
                      v-bind:false-value="0"
                      name="flavour-2"
                    >
                      <b-form-checkbox value="true">Avançada</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>
                </div>
                <div v-if="isAdmin">
                  <b-form-group v-if="temporaryDesign && temporaryDesign.customColors" label="Camada colorida:">
                    <b-input type="number" v-model="layer"/>
                  </b-form-group>
                </div>
                <div v-if="isAdmin">
                  <b-form-group label="Moldura:">
                    <b-form-checkbox-group
                      id="checkbox-group-2"
                      v-model="temporaryDesign.frame"
                      v-bind:true-value="1"
                      v-bind:false-value="0"
                      name="flavour-2"
                    >
                      <b-form-checkbox value="true">Marcar como moldura</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>
                </div>
                <div v-if="isAdmin">
                  <b-form-group label="Exerícios Personalizados:">
                    <b-form-checkbox-group
                      id="checkbox-group-2"
                      v-model="temporaryDesign.exercises"
                      v-bind:true-value="1"
                      v-bind:false-value="0"
                      name="flavour-2"
                    >
                      <b-form-checkbox value="true">Marcar como moldura</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>
                </div>
                <p class="text-muted text-center" v-if="isAdmin && temporaryDesign && !temporaryDesign.customColors">Relevância do Template</p>
                <b-input-group class="mb-3" v-if="isAdmin && temporaryDesign && !temporaryDesign.customColors">
                  <b-form-input
                    type="number"
                    class="form-control"
                    placeholder="Digite um número maior que 0"
                    v-model="temporaryDesign.weight"
                  />
                </b-input-group>
                  <p class="text-muted text-center" v-if="isAdmin && temporaryDesign && !temporaryDesign.customColors">Sugestão de Legenda</p>
                <b-input-group class="mb-6" v-if="isAdmin && temporaryDesign && !temporaryDesign.customColors">
                  <b-form-textarea
                    v-if="temporaryDesign"
                    class="form-control"
                    placeholder="Digite a sugestão de Legenda"
                    v-model="temporaryDesign.subtitle"
                  />
                  </b-input-group>
                  <p v-if="isAdmin && temporaryDesign && temporaryDesign.subtitle" v-bind:style="temporaryDesign.subtitle.length > 2100 ? {color: 'red'} : {}">{{!temporaryDesign.subtitle ? 0 : temporaryDesign.subtitle.length}}/2200 {{temporaryDesign.subtitle.length > 2100 ? " -  Atenção: Verificar no Facebook Studio antes de salvar.": ""}}</p>
                  <p class="text-muted text-center" v-if="isAdmin">Versão Original</p>
                <b-input-group class="mb-6" v-if="isAdmin">
                  <b-form-input
                    class="form-control"
                    placeholder="Digite o template original, se essa for uma versão"
                    v-model="temporaryDesign.originalVersion"
                  />
                  
                </b-input-group>
                <div class="form-actions" style="margin-top: 10px !important;">
                  <b-row>
                    <b-col lg="6">
                      <b-button
                        type="button"
                        v-if="!savingTemplate"
                        v-on:click="saveTemplate"
                        variant="primary"
                      >Salvar</b-button>
                      <spinner id="loadingDiv" v-if="savingTemplate"></spinner>
                    </b-col>
                    <b-col lg="6">
                      <b-button
                        type="button"
                        v-on:click="saveAdminTemplate"
                        v-if="isAdmin"
                        variant="primary"
                      >Salvar como Admin</b-button>
                    </b-col>
                  </b-row>
                </div>
              </b-form>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
  <div class="animated fadeIn" v-else>
    <spinner id="loadingDiv"></spinner>
  </div>
</template>

<script>
import service from "./../service";
import Multiselect from "vue-multiselect";
import Spinner from "./Spinner";
import Config from "../config";
import { isIOS } from "mobile-device-detect";
import { isMobile } from "mobile-device-detect";
import axios from "axios";
import SubtitleBox from "./SubtitleBox"
import RelatedPosts from "./RelatedPosts"

export default {
  name: "SaveDesign",
  props: {
    dontUseCredits: false
  },
  data() {
    return {
      loaded: false,
      selectedCategories: [],
      taggingSelected: null,
      categoriesList: [],
      temporaryDesign: undefined,
      random: Math.random(),
      savingTemplate: false,
      me: undefined,
      isIOS: isIOS,
      isMobileScreen: isMobile,
      canDownloadFree: false,
      color: "",
      layer: 2,
      canFindImage: false,
      challenge: ""

    };
  },
  computed: {
    fullImage: function() {
      if (this && this.temporaryDesign && this.temporaryDesign.fullImage) {
        return this.temporaryDesign.fullImage + "?" + this.random;
      } else {
        return "";
      }
    },
    watermarked: function() {
      return (
        (this.temporaryDesign.watermarkedNeutral
          ? this.temporaryDesign.watermarkedNeutral
          : this.temporaryDesign.watermarked
          ? this.temporaryDesign.watermarked
          : this.fullImage) +
        "?" +
        this.random
      );
    },
    isAdmin: function() {
      return localStorage.admin;
    },
    templateName() {
      return localStorage.templateName;
    },
    whitelabelName() {
      return localStorage.whitelabelName;
    },
    isInstagramBrowser: function() {
      var str = navigator.userAgent;
      var i = str.indexOf("Instagram");
      if (i <= -1) {
        return false;
      }
      return true;
    }
  },
  methods: {
    goToChallenge() {
      this.$router.push({name: "Challenge", params: {id: this.challenge}});
    },
    goToTemplate: function(id) {
      this.$router.push({ name: 'Preview Design', params: { id: id }});
    },
    notLoaded: function() {
      setTimeout(() => (this.random = Math.random()), 2000);
    },
    addTag: function(newTag) {
      const tag = {
        name: newTag
      };
      this.categoriesList.push(tag);
      this.selectedCategories.push(tag);
    },
    getAllCategories: function() {
      return fetch(baseURL + "categories", {
        method: "GET"
      }).then(function(response) {
        if (response && response.status && response.status === 200) {
          return response.json();
        } else {
          return Promise.reject();
        }
      });
    },
    downloadItem(url) {
      console.log("URL: " + url);
      axios
        .get(url, { responseType: "blob" })
        .then(({ data }) => {
          const blob = new Blob([data], { type: "image/png" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = localStorage.whitelabelName + ".png";
          link.click();
        })
        .catch(error => console.error(error));
    },
    saveTemplate: function() {
      this.savingTemplate = true;
      var express = false;
      var advanced = false;

      if (this.temporaryDesign.expressEdition) {
        express = JSON.parse(this.temporaryDesign.expressEdition);
      }
      if (this.temporaryDesign.advancedEdition) {
        advanced = JSON.parse(this.temporaryDesign.advancedEdition);
      }

      service
        .saveTemplate({
          temporaryTemplateId: this.temporaryDesign._id,
          categories: this.selectedCategories,
          expressEdition: express,
          advancedEdition: advanced,
          weight: this.temporaryDesign.weight
        })
        .then(
          response => {
            this.savingTemplate = false;
            this.$router.push("/design/mine/");
          },
          () => {
            this.savingTemplate = false;
            this.showError = true;
          }
        );
    },
    getMe: function() {
      service.getMe().then(user => {
        this.me = user;
      });
    },
    tryToGetImages: function() {
      this.random = Math.random();
      if (this.canFindImage) {
        return;
      }

      fetch(this.watermarked).then((result) => {
        if (result.status == 200) {
          fetch(this.fullImage).then((result) => {
            if (result.status == 200) {
              this.canFindImage = true;
            }
          }).catch((error) => {
            console.log(error);
          });
        }
      }).catch((error) => {
        console.log(error);
      });

      setTimeout(this.tryToGetImages, 2000);
    },
    saveAdminTemplate: function() {
      let express = false;
      let advanced = false;
      let weight = 0;
      let frame = false;

      if (this.temporaryDesign.expressEdition) {
        express = JSON.parse(this.temporaryDesign.expressEdition);
      }
      if (this.temporaryDesign.advancedEdition) {
        advanced = JSON.parse(this.temporaryDesign.advancedEdition);
      }
      if (this.temporaryDesign.weight) {
        weight = JSON.parse(this.temporaryDesign.weight);
      }

      if (this.temporaryDesign.frame) {
        frame = JSON.parse(this.temporaryDesign.frame);
      }

      /*if (this.temporaryDesign.frame) {
        exercises = JSON.parse(this.temporaryDesign.exercises);
      }*/

      service
        .saveAdminTemplate({
          temporaryTemplateId: this.temporaryDesign._id,
          categories: this.selectedCategories,
          expressEdition: express,
          advancedEdition: advanced,
          weight: weight,
          subtitle: this.temporaryDesign.subtitle,
          frame: frame,
          customColors: this.temporaryDesign.customColors,
          originalVersion: this.temporaryDesign.originalVersion,
          color: this.color,
          layer: this.layer
        })
        .then(
          response => {
            if (response && response.id) {
              this.$router.push("/design/preview/" + response.id);
            } else {
              this.$router.push({ name: 'Busca', params: { page: 1 }});
            } 
          },
          () => {
            this.showError = true;
          }
        );
    }
  },
  mounted: function() {
    
  },
  created: function() {
    if (this.$route.query.challenge) {
      this.challenge = this.$route.query.challenge;
    }

    if (this.$route.params.token) {
      let token = this.$route.params.token.replace("instagram1a","");
      localStorage.sessionId = token;
    }

    this.getMe();
    if (this.$route.params.id) {
      service.getTemporaryDesign(this.$route.params.id).then(
        response => {
          this.temporaryDesign = response.temporaryDesign;
          this.temporaryDesign.expressEdition = true;
          this.temporaryDesign.advancedEdition = true;
          let preselectedCategories = response.preselectedCategories;
          this.tryToGetImages();
          if (this.temporaryDesign.originalIsPersonal || this.$route.params.dontUseCredits) {
            console.log(1);
            this.canDownloadFree = true;
          } else {
            console.log(2);
            service.useCredits(this.$route.params.id).then(
              response => {
                if (response.status == "ok") {
                  this.canDownloadFree = true;
                  // Create the event
                  var event = new CustomEvent("update-me", {});

                  // Dispatch/Trigger/Fire the event
                  document.dispatchEvent(event);
                }
              },
              (error) => {
                if (error && error.message) {
                  alert(error.message);
                } else {
                  alert("Houve um erro, por favor contate o suporte. Código: 2857.69");
                }
              }
            );
          }
          
          service.getAllCategoriesAndUserCategories(this.temporaryDesign.story).then(
            response => {
              this.categoriesList = response;

              if (preselectedCategories) {
                for (let key  in this.categoriesList) {
                  let category = this.categoriesList[key];
                  if (preselectedCategories.indexOf(category._id) >= 0) {
                    this.selectedCategories.push(category);
                  }
                }
              }
            },
            () => {
              this.showError = true;
            }
          );
        },
        () => {
          this.showError = true;
        }
      );
    }
  },
  components: { Multiselect, Spinner, SubtitleBox, RelatedPosts }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



<style lang="css" scoped>
.background-multiSelect >>> .multiselect__tag {
  background: #20a8d8 !important;
}
</style>


<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
